import React from 'react';
import { OfferErrorView } from './OfferErrorView';

const OfferErrorController = props => {
  return <OfferErrorView {...props} />;
};

export { OfferErrorController as OfferError };
